import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  Grid,
  TextField,
  Divider,
  IconButton,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddBoxRoundedIcon from "@material-ui/icons/AddBoxRounded";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";
import FacebookAdSetContext from "../../../../context/facebook_profiles/adset/AdSetContext";
import FacebookAdContext from "../../../../context/facebook_profiles/ad/AdContext";

// Components
import CancelAlert from "./CancelAlert";
import Video from "./Video";
import Form from "./Form";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: "1rem",
    marginLeft: "8px",
    height: 700,
  },
  paperBox: {
    padding: "0.5rem",
  },
  row: {
    width: "100%",
  },
  divider: {
    width: "100%",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },
  rowContent: {
    height: 500,
    width: "100%",
  },
  title: {
    fontSize: "0.9rem",
    marginLeft: "0.5rem",
  },
  addBox: {
    "&:focus": {
      outline: "none",
    },
  },
  addButton: {
    color: theme.palette.text.primary,
  },
  rowPaper: {
    width: "99%",
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem",
    marginBottom: "0.5rem",
  },
  rowForm: {
    height: 320,
    width: "99%",
    overflowY: "auto",
    margin: "1rem auto 1rem",
  },
  buttonBox: {
    textAlign: "center",
    marginLeft: "0.5rem",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const CreateAd = () => {
  const classes = useStyles();

  const {
    selected_fb_details,
    selected_profile,
    setDisplayContent,
    getCampaignStats,
    campaign_stats,
    getAdSetStats,
    adset_stats,
  } = useContext(FacebookProfilesDashboardContext);
  const { campaign_id, adset_id } = useContext(FacebookAdSetContext);
  const {
    video_url,
    setVideoUrl,
    setVideoError,
    default_form,
    default_error,
    form_details,
    setFormDetails,
    form_errors,
    setFormErrors,
    resetForm,
    createAd,
  } = useContext(FacebookAdContext);

  const [bm, setBm] = useState();
  const [ad, setAd] = useState();
  // const [pixels, setPixels] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [adsetList, setAdsetList] = useState([]);
  const [adsetid, setAdsetid] = useState("");
  const [adsetidError, setAdsetidError] = useState("");

  const modalClose = () => {
    // Continue Edit Ad Set
    setModalOpen(false);
  };

  const modalSave = () => {
    // Back To Overview
    setDisplayContent();
    setVideoUrl();
    setVideoError();
    resetForm();
  };

  const handleChange = (e) => {
    // Adset ID Selection
    setAdsetid(e.target.value);
    setAdsetidError("");
  };

  const handleDuplicate = () => {
    let name_list = {};

    // Cross Check Duplicate Ad Name
    form_details.map((each, index) => {
      if (each.name) {
        if (!Object.keys(name_list).includes(each.name)) {
          name_list[each.name] = [index];
        } else {
          name_list[each.name].push(index);
        }
      }
    });

    // Remove Error Message
    form_errors.map((error) => {
      if (error["name"] === "Ad name duplicated!") {
        error["name"] = "";
      }
    });

    // Insert Error Message
    Object.values(name_list).map((indexes) => {
      if (indexes.length > 1) {
        indexes.map((index) => {
          form_errors[index]["name"] = "Ad name duplicated!";
        });
      }
    });

    setFormDetails(form_details);
    setFormErrors(form_errors);
  };

  const addAd = (e) => {
    // Add New Ad
    let last_idx = Object.keys(form_details).pop();
    last_idx = last_idx ? last_idx : 0;
    const new_idx = last_idx === 0 ? 0 : parseInt(+last_idx + 1);

    form_details[new_idx] = default_form;
    form_errors[new_idx] = default_error;

    setFormDetails(form_details);
    setFormErrors(form_errors);
  };

  const removeAd = (e) => {
    // Remove Ad
    form_details.splice(e.target.name, 1);
    form_errors.splice(e.target.name, 1);

    // Prevent Empty Ad Set
    if (Object.keys(form_details).length === 0) {
      addAd();
    }

    handleDuplicate();
  };

  const onCancel = () => {
    // Open Modal - Cancel Creation
    setModalOpen(true);
  };

  const onCreate = (e) => {
    // Save Ad
    e.preventDefault();

    let next = true;

    if (!adsetid) {
      setAdsetidError("Select one ad set!");
      next = false;
    }

    if (!video_url) {
      setVideoError("Video is not selected or uploaded!");
      next = false;
    }

    form_errors.map((error) => {
      Object.values(error).map((err) => {
        if (err) next = false;
      });
    });

    form_details.map((details, index) => {
      Object.entries(details).map(([id, val]) => {
        if (id === "image") {
          if (val === "") {
            form_errors[index][id] = "Image is not selected or uploaded!";
            next = false;
          }
        } else {
          let name;

          if (id === "name") name = "Name";
          if (id === "page_id") name = "Page ID";
          if (id === "CTA") name = "CTA";
          if (id === "link") name = "Link";

          if (val === "") {
            form_errors[index][id] = `${name} cannot be empty!`;
            next = false;
          }
        }
      });
    });

    setFormDetails(form_details);
    setFormErrors(form_errors);

    if (next) createAd(selected_profile.profile_id, ad.ad_account_id, adsetid);
  };

  useEffect(() => {
    selected_profile.bm_account.map((bm) => {
      if (bm.bm_account_id === selected_fb_details.business_manager) {
        setBm(bm);
      }
    });

    selected_profile.ad_account.map((ad) => {
      if (ad.ad_account_id === selected_fb_details.ad_account) {
        setAd(ad);
        // setPixels(ad.pixels);
        // Onload Create New Ad
        addAd();
      }
    });

    // Get Adset List
    if (adset_id.length === 0) {
      // From ad tab
      getCampaignStats(selected_profile);
    }

    getAdSetStats(selected_profile);
  }, []);

  useEffect(() => {
    if (adset_stats.length > 0) {
      let new_list = [];

      if (adset_id.length === 0 && campaign_stats.length > 0) {
        // From ad tab - get adset list from selected campaign
        new_list = adset_stats;
      } else {
        // From adset page
        adset_stats.map((adset) => {
          if (adset_id.includes(adset.id)) {
            new_list.push(adset);
          }
        });
      }

      setAdsetList(new_list);
    }
  }, [campaign_stats, adset_stats]);

  return (
    <Paper className={classes.paper}>
      <CancelAlert
        modalOpen={modalOpen}
        modalClose={modalClose}
        modalSave={modalSave}
      />
      <Grid
        container
        className={classes.paperBox}
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Grid item className={classes.row}>
          <Grid item xs={4} container direction="column" spacing={1}>
            <Grid item>
              <TextField
                fullWidth
                disabled
                size="small"
                margin="dense"
                label="Business Manager"
                id="business_manager"
                name="business_manager"
                value={bm ? `${bm.bm_account_name} (${bm.bm_account_id})` : ""}
              />{" "}
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                disabled
                size="small"
                margin="dense"
                label="Ad Account"
                id="ad_account"
                name="ad_account"
                value={ad ? `${ad.ad_account_name} (${ad.ad_account_id})` : ""}
              />{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Grid>
        <Grid item className={classes.divider}>
          <Divider variant="fullWidth" />
        </Grid>
        {/* Content */}{" "}
        <Grid container direction="row" item className={classes.rowContent}>
          <Grid item xs={5} className={classes.rowPaper}>
            <TextField
              required
              fullWidth
              variant="outlined"
              select
              SelectProps={{
                native: true,
              }}
              size="small"
              margin="dense"
              label="Ad Set"
              id="adsetid"
              name="adsetid"
              value={adsetid ? adsetid : "select"}
              onChange={handleChange}
              error={adsetidError ? true : false}
              helperText={adsetidError ? adsetidError : ""}
            >
              <option value="select" disabled>
                -- - select one-- -
              </option>{" "}
              {adsetList.map((each) => {
                return (
                  <option key={each.id} value={each.id}>
                    {" "}
                    {each.name}({each.id}){" "}
                  </option>
                );
              })}{" "}
            </TextField>{" "}
          </Grid>
          <Video />
          <Grid item className={classes.row}>
            <div>
              <span className={classes.title}> Ad: </span>&ensp;{" "}
              <IconButton
                size="small"
                onClick={addAd}
                className={classes.addBox}
              >
                <AddBoxRoundedIcon className={classes.addButton} />{" "}
              </IconButton>{" "}
            </div>{" "}
          </Grid>
          <Grid item className={classes.rowForm}>
            {" "}
            {form_details.map((ad, index) => {
              return (
                <Form
                  key={index}
                  ad_id={index}
                  ad_details={ad}
                  remove={removeAd}
                  handleDuplicate={handleDuplicate}
                />
              );
            })}{" "}
          </Grid>{" "}
        </Grid>
        <Grid
          item
          className={classes.row}
          container
          justifyContent="flex-end"
          alignItems="center"
        >
          <Grid item className={classes.buttonBox}>
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={onCancel}
            >
              Cancel{" "}
            </Button>{" "}
          </Grid>
          <Grid item className={classes.buttonBox}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={onCreate}
            >
              Next{" "}
            </Button>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Grid>{" "}
    </Paper>
  );
};

export default CreateAd;
